export * from './edit-image-modal.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/edit-image-modal/index.ts